import React, { useEffect, useState } from "react";
import FilterForm from "./FilterComponent";
import InboxTable from './InboxTable'
import { TLService } from "../../../../../../libraries/src/services/elements/TL";
import { FaFileExcel } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { ConvertEpochToDate } from "@egovernments/digit-ui-libraries/src/services/atoms/Utils/Date";
import { Box, Tab } from "@mui/material";   // ✔ Use MUI Tab
import { makeStyles } from '@material-ui/core/styles';
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { PrintIcon } from "@egovernments/digit-ui-react-components";
import ReactToPrint from "react-to-print";

const useStyles = makeStyles((theme) => ({
  customTab: {
    backgroundColor: '#1F4A7C',
    color: 'white',
    marginRight: '3px',
    borderRadius: '3px',
    padding: '6px 12px',
    '&.Mui-selected': {
      backgroundColor: 'transparent',
      color: 'black',
      border: `1px solid ${theme.palette.primary.main}`,
    },
  },
}));

function DashboardDetails({ type }) {
  const classes = useStyles()
  const { t } = useTranslation();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const [apiData, setApiData] = useState(null);
  const [value, setValue] = React.useState('1');
  const componentPDF = React.useRef();

  const fetchData = async (params) => {
    const result = await TLService.misReportRegistration(tenantId, params);
    setApiData(result);
  };

  const onSubmit = async (data) => {
    const params = {
      formType: data?.formType,
      mobileNumber: data?.mobileNumber,
      applicationNumber: data?.applicationNumber,
      licenseNumbers: data?.licenseNumbers,
    };
    await fetchData(params)
  };

  const handleChange = (_, newValue) => {
    setValue(newValue);
  };

  const handleExcelDownload = () => {
    const charData = apiData?.Licenses?.map((st) => ({
      applicationnumber: st?.applicationNumber,
      servicetype: st?.licenseType,
      status: st?.status,
      district: st?.tradeLicenseDetail?.owners?.[0]?.correspondenceAddress?.district,
      Department: st?.department,
      professional_emailid: st?.tradeLicenseDetail?.owners?.[0]?.emailId,
      professional_mobilenumber: st?.tradeLicenseDetail?.owners?.[0]?.mobileNumber,
      created_date: ConvertEpochToDate(Number(st?.applicationDate)),
    }));
    return Digit.Download.Excel(charData, "application-report");
  };

  useEffect(() => {
    fetchData({ stateStatus: type });
  }, []);

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <TabContext value={value}>
          <Box
            sx={{
              borderBottom: 1,
              borderColor: 'divider',
              display: 'flex',
              alignItems: 'center'
            }}
          >
            {/* LEFT SIDE — Tabs */}
            <TabList onChange={handleChange} aria-label="tabs" sx={{ justifyContent: "flex-start" }}>
              <Tab label="Registration Reports" value="0" className={classes.customTab} />
            </TabList>

            {/* RIGHT SIDE — Buttons */}
            <div style={{ marginLeft: "auto", display: "flex", gap: "1.5rem" }}>
              <ReactToPrint
                trigger={() => (
                  <button id="invoice-print">
                    <PrintIcon />
                  </button>
                )}
                content={() => componentPDF.current}
              />

              <button
                className="mrlg cursorPointer"
                onClick={handleExcelDownload}
              >
                <FaFileExcel style={{ fontSize: '22px' }} />
              </button>
            </div>
          </Box>
        </TabContext>
      </div>

      <FilterForm type={type} onSubmit={onSubmit} />
      <InboxTable apiData={apiData} type={type} ref={componentPDF} />
    </div>
  );
}

export default DashboardDetails;
